// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import api from './api' // 导入api接口

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/style/index.scss' // global css

// 分页
import Pagination from "@/components/pagination";
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import style (>= Swiper 6.x)
// import 'swiper/swiper-bundle.css'
// import style (<= Swiper 5.x)
import 'swiper/dist/css/swiper.css'

import axios from 'axios';

router.beforeEach((to, form, next) => {
  if (to.meta.title) {
      document.title = to.meta.title
  } else {
      document.title = '默认标题' //此处写默认的title
  }
  document.documentElement.scrollTop = 0
  next()
})

// 全局挂载
Vue.component('Pagination', Pagination)

Vue.prototype.$http = axios;
Vue.prototype.$api = api;

Vue.use(ElementUI);
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js